<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: {
    source: {
      type: Array,
      required: true
    },
    since: {
      type: Object,
      required: false
    },
    until: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      datasets: [],
      graphOptions: {
        responsive: true,
        // aspectRatio: 5,
        maintainAspectRatio: false,
        animation: {
          duration: 0 // general animation time
        },
        legend: {
          display: false //凡例がズレるかどうかのデバッグ用
        },
        title: {
          display: false
        },
        scales: {
          xAxes: [
            {
              type: "time",
              time: {
                round: true,
                displayFormats: {
                  //'second': 'MMM DD HH:mm:ss',  //秒を表示したい場合
                  'minute': 'M/DD HH:mm',
                  'hour': 'M/DD HH:mm',
                  'day': 'M/DD',
                  'month': 'M'
                }
              },
              Distribution: "linear",
              ticks: {
                source: "auto",
                maxRotation: 70,
                minRotation: 70,
              }
            }
          ],
        }
      }
    };
  },
  watch: {
    source: function() {
      this.change_bgcolor("#EEEEEE")
    }
  },
  mounted() {
    this.change_bgcolor("#EEEEEE")
  },
  methods: {
    change_bgcolor(color){ //引数の例:"rgb(255,255,255)"
      this.addPlugin({
        beforeDraw: function (c) {
          var ctx = c.chart.ctx
          ctx.fillStyle = color
          ctx.fillRect(0, 0, c.chart.width, c.chart.height)
        }
      }),
      this.routing_graph()
    },
    createdatasets() {
      this.datasets = [];
      for (let i = 0; i < this.source.length; i++) {
        //グラフ作成
        const dataelement = {
          yAxisID: "y-" + i,
          backgroundColor: "black", //黒に固定
          borderColor: this.source[i].color,
          pointBackgroundColor: this.source[i].color,
          fill: false,
          lineTension: 0,
          data: this.source[i].plotdata
        };
        this.datasets.push(dataelement);
      }
      return this.datasets;
    },
    getGraphTicks() {
      let min
      let max
      if(this.$store.state.graph.options.datamode == "limit_mode"){
        min = null
        max = null
      }
      
      if (this.since) {
        min = this.since.tz("Asia/Tokyo").format();
      }
      if (this.until) {
        max = this.until.tz("Asia/Tokyo").format();
      }
      return {min, max}
    },
    renderGraph: function() {
      this.createdatasets()
      const {min, max} = this.getGraphTicks()
      this.graphOptions.scales.xAxes[0].ticks.min = min
      this.graphOptions.scales.xAxes[0].ticks.max = max
      this.graphOptions.scales.yAxes = [
        {
          scaleLabel: {
            display: true,
            labelString: this.source[0].name,
            fontSize: 18,
            fontColor: "#333"
          },
          id: "y-0",
          position: "left",
          ticks: {
            source: "auto",
            beginAtZero: false
          }
        }
      ]
      this.renderChart({
        datasets: this.datasets
      }, this.graphOptions)
    },
    renderGraph2: function() {
      this.createdatasets()
      const {min, max} = this.getGraphTicks()
      this.graphOptions.scales.xAxes[0].ticks.min = min
      this.graphOptions.scales.xAxes[0].ticks.max = max
      this.graphOptions.scales.yAxes = [
        {
          scaleLabel: {
            display: true,
            labelString: this.source[0].name,
            fontSize: 18,
            fontColor: "#333"
          },
          id: "y-0",
          position: "left",
          ticks: {
            source: "auto",
            beginAtZero: false
          }
        },
        {
          scaleLabel: {
            display: true,
            labelString: this.source[1].name,
            fontSize: 18,
            fontColor: "#428BCA"
          },
          id: "y-1",
          position: "right",
          ticks: {
            source: "auto",
            beginAtZero: false
          }
        }
      ]
      this.renderChart({
          datasets: this.datasets
      }, this.graphOptions)
    },
    routing_graph(){
      if(this.source.length == 1){
        this.renderGraph()
      }else if(this.source.length == 2){
        this.renderGraph2()
      }
    }
  }
};
</script>
